import type { QuickStepActionType, QuickStepAction } from 'owa-quick-step-types';
import { owaComputedFn } from 'owa-computed-fn';
import type { ClientItemId } from 'owa-client-ids';
import { getIsPopoutButtonDisabled } from 'owa-mail-ribbon-utils/lib/getIsPopoutButtonDisabled';
import { type MailRibbonControlId } from 'owa-ribbon-ids/lib/mailRibbonId';

export const getIsQuickStepDisabledForPopout: (
    actions: QuickStepAction[],
    clientId: ClientItemId | undefined
) => boolean = owaComputedFn(
    (actions: QuickStepAction[], clientId: ClientItemId | undefined): boolean => {
        for (let i = 0; i < actions.length; i++) {
            if (actions[i].type == 'createTask') {
                continue;
            }
            const ribbonId = getRibbonIdFromActionType(actions[i].type);
            // If the ribbonId is not found, it means the action type is not supported
            if (!ribbonId) {
                return true;
            }
            // Does this need to check shown/hidden as well?
            if (getIsPopoutButtonDisabled(ribbonId, clientId)) {
                return true;
            }
        }
        return false;
    }
);

// function exported for tests
export function getRibbonIdFromActionType(
    type: QuickStepActionType
): MailRibbonControlId | undefined {
    // It's possible the map doesn't contain the type, if so return the bad item type
    return ActionTypeToRibbonIdMap.get(type);
}

const ActionTypeToRibbonIdMap: Map<QuickStepActionType, MailRibbonControlId> = new Map<
    QuickStepActionType,
    MailRibbonControlId
>([
    ['markAsRead', 552],
    ['markAsUnread', 552],
    ['delete', 519],
    ['softDelete', 519],
    ['moveTo', 540],
    ['copyTo', 540],
    ['category', 509],
    ['clearCategories', 509],
    ['forwardTo', 555],
    ['forwardAsAttachment', 651],
    ['flag', 527],
    ['clearFlags', 527],
    ['markComplete', 527],
    ['retentionPolicy', 616],
    ['pin', 548],
    ['unpin', 548],
    ['ignore', 531],
    ['snooze', 571],
    ['replyWithMeeting', 553],
    ['copilotReplyWithMeeting', 696],
]);
